import { render, staticRenderFns } from "./fund-full-width-quote-panel.vue?vue&type=template&id=537c8f66&scoped=true&"
var script = {}
import style0 from "../../../assets/styles/panels/_QuotesPanel.scss?vue&type=style&index=0&id=537c8f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c8f66",
  null
  
)

export default component.exports